import React from 'react'

const site = JSON.parse(localStorage.getItem('site'))
const acc = JSON.parse(localStorage.getItem('acc'))

import { ReactComponent as OperationOrderHistory } from '../assets/svg/Header/OperationOrderHistory.svg'
import { ReactComponent as OperationLogisticList } from '../assets/svg/Header/OperationLogisticList.svg'
import { ReactComponent as OperationDebtors } from '../assets/svg/Header/OperationDebtors.svg'
import { ReactComponent as OperationBuyer } from '../assets/svg/Header/OperationBuyer.svg'

export const histories = [
  {
    permission: true,
    link: '/admin/ordersHistory',
    name: 'Order History',
    icon: (
      <OperationOrderHistory
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: false,
  },
  {
    permission: true, // Права теперь проверяются динамически
    link: '/admin/logistic/history',
    name: 'Lista Entregas History',
    icon: (
      <OperationLogisticList
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.shopping,
    // link: '/admin/buyer',
    link: '/buyerList',
    name: `Buyer ${localStorage.getItem('name') === 'TPO' ? '' : 'CCN'} History`,
    icon: <OperationBuyer width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/productsManager/history',
    name: 'Factura History',
    icon: (
      <OperationDebtors width={'30px'} height={'30px'} />
    ),
    enabled: true,
    disabled: false,
  },
]
